var React = require('react');

function Search (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"icons / search"),React.createElement("g",{"id":"icons-/-search","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":1},React.createElement("path",{"d":"M9.5,15 C6.467,15 4,12.533 4,9.5 C4,6.467 6.467,4 9.5,4 C12.533,4 15,6.467 15,9.5 C15,12.533 12.533,15 9.5,15 L9.5,15 Z M22.707,21.293 L15.457,14.043 C16.421,12.782 17,11.21 17,9.5 C17,5.358 13.642,2 9.5,2 C5.358,2 2,5.358 2,9.5 C2,13.642 5.358,17 9.5,17 C11.21,17 12.782,16.421 14.043,15.457 L21.293,22.707 L22.707,21.293 Z","id":"search","fill":"#1E1E1E"}))]);
}

Search.defaultProps = {"width":"24px","height":"24px","viewBox":"0 0 24 24","version":"1.1"};

module.exports = Search;

Search.default = Search;
